import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import FarewellBernie from '@/components/FarewellBernie'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'FarewellBernie',
      component: FarewellBernie
    },
    {
      path: '/helloworld',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js